import { Dictionary } from 'vuex';

export interface Settings {
  localisations: I18N[];

  company: string;
  logo: string;
  logoSmall: string;
  brand: string;
  privacyPolicy: string;
  termsOfUse: string;

  accessFrequency: string;
  accessReason: string;
  accessPeriod: string;
  accessDataType: string;

  daysOfTransactions: number;

  textOverrides: ITextOverrides;
  theme: ISignupTheme;

  consentTermPrivacyCheckbox: boolean;
}

export enum I18N {
  EnGb = 0,
  EnUs = 1,

  PtPt = 500,
}

export enum SignupField {
  Login = 'Login',
  UseEmailAsLogin = 'UseEmailAsLogin',

  //#region about you
  Firstname = 'Firstname',
  Lastname = 'Lastname',
  Email = 'Email',
  Telephone = 'Telephone',

  CustomerReference = 'CustomerReference',
  DateOfBirth = 'DateOfBirth',
  //#endregion

  //#region employment
  EmploymentStatus = 'EmploymentStatus',

  CompanyName = 'CompanyName',
  JobTitle = 'JobTitle',
  Salary = 'Salary',
  PayFrequency = 'PayFrequency',
  //#endregion

  //#region Address
  ResidentialAddress = 'ResidentialAddress',

  Postcode = 'Postcode',
  //#endregion

  ShowExternalRef = 'ShowExternalRef',

  ShowTerms = 'ShowTerms',
  ShowPriv = 'ShowPriv',

  ShowConsent = 'ShowConsent',
}
export interface ISignupField {
  Login: string;
  UseEmailAsLogin: boolean;
  BankId: string;

  //#region about you
  Firstname: string;
  Lastname: string;
  Email: string;
  Telephone: string;

  CustomerReference: string;
  DateOfBirth: string;
  //#endregion

  //#region employment
  EmploymentStatus: string;

  CompanyName: string;
  CompanyNumber: string;
  JobTitle: string;
  Salary: string;
  PayFrequency: string;
  //#endregion

  //#region Address

  /**
   * used to check if the client wants the address
   */
  ResidentialAddress: boolean;

  AddressLine1: string;
  AddressLine2: string;
  City: string;

  Postcode: string;

  //#endregion
    
  ShowExternalRef: string;

  ShowTerms: boolean;
  ShowPriv: boolean;

  ShowConsent: boolean;

  AcceptPrivPolicy: boolean;
  AcceptTermsConditions: boolean;
  ConsentGiven: boolean;
  CreateConsentsOnlineAccount: boolean;
}

export interface ISignupTheme {
  /* APP */
  background?: string;

  headerBackground?: string;
  footerBackgroundColor?: string;

  headerForegroundColor?: string;
  footerForegroundColor?: string;

  bodyForegroundColor?: string;
  titleForegroundColor?: string;
  /* /APP */

  /* BUTTON */
  buttonBackground?: string;
  buttonBorder?: string;
  buttonForegroundColor?: string;

  buttonAccentBackground?: string;
  buttonAccentBorder?: string;
  buttonAccentForeground?: string;

  buttonHoverBackground?: string;
  buttonHoverForegroundColor?: string;
  buttonHoverBorder?: string;

  buttonActiveBackground?: string;
  buttonActiveForegroundColor?: string;
  buttonActiveBorder?: string;

  /* /BUTTON */

  /* INPUT  */

  inputBackground?: string;
  inputBorder?: string;
  inputForegroundColor?: string;

  inputDisabledBackground?: string;
  inputDisabledBorder?: string;
  inputDisabledForegroundColor?: string;

  inputFocusBackground?: string;
  inputFocusBorder?: string;
  inputFocusForegroundColor?: string;

  inputPlaceholderForegroundColor?: string;

  inputSelectionForegroundColor?: string;
  inputSelectionBackground?: string;

  /* /INPUT  */
}

enum SignupErrorCode {
  InvalidOperation = 1,
  ValidationError = 2,

  /* IBIS */
  IbisInvalidDetails = 50,
  IbisAdditionInvalidDetails = 150,
  IbisAdditionUserActionRequired = 151,
  IbisBankDown = 53,
  IbisAdditionBankDown = 153,
  IbisMFAError = 55,
  IbisAdditionMFAError = 155,
  IbisAccountLocked = 59,
  IbisAdditionAccountLocked = 159,
  IbisFileUploadError = 60,
  IbisMfaNeedsCompleting = 99,
  CompletedNoTransactions = 102,
  AdditionCompletedNoTransactions = 202,
  /* /IBIS */
}

interface SignupException {
  code: SignupErrorCode;
  message: string;
}

interface SignupValidationException extends SignupException {
  error: string[];
}

export interface IBankSearchRequest extends IPagedRequest {
  name: string;
  allowedProviders?: number[];
}

export interface IBankSearchResponse extends IPagedResult<IBankItem> {}

export interface IBankItem {
  id: string;
  code: string;
  description: string;
  logo: string;
}

export interface IBankProvider {
  dataProviderId: number;

  bankId: string;

  allowedProviders: number[];
}

export interface IBankStrategy {
  type: string;
  data: IBankStrategyData;
}
// tslint:disable-next-line:no-empty-interface
export interface IBankStrategyData {
  requestId: string;
  state: string;
}

export interface OpenBankingStrategyData extends IBankStrategyData {
  state: string;
  redirectUrl: string;
  requestId: string;
  disableNewTab:boolean;
}

export interface OpenBankingStrategy extends IBankStrategy {
  data: OpenBankingStrategyData;
}

export interface YodleeStrategyData extends IBankStrategyData {
  state: string;
  requestId: string;
  fields: ISignupPageField[];
}
export interface YodleeStrategy extends IBankStrategy {
  data: YodleeStrategyData;
}

export interface IProcessBankStrategy {
  state: string;
  requestId: string;
}
export interface ICustomerAccountRequest{
  accountId:string
}
export interface IReverseLookupInfoRequest {
  requestId: string;
  clientCode:string;
  timeOut:number;
}
export interface IReverseLookupResponses{
  success:boolean;
  error:string
  reverseLookupInfoResponse:IReverseLookupInfoResponse;
  reverseLookupResponce:IReverseLookupResponse
}
export interface IReverseLookupInfoResponse {
  success:boolean;
  error:string
  title: string;
  firstname:string;
  lastname:string;
  dateOfBirth: string,
}
export interface IReverseLookupResponse{
  success:boolean;
  error:string
  number:string;
  name:string;
  street1:string;
  street2:string;
  subBuilding:string;
  district:string;
  country:string; 
  poBox:string;
  postTown:string;
  postcode:string;
}

export interface IProcessBankStrategyYodlee extends IProcessBankStrategy {
  data: {
    fields: Dictionary<string>;
    isMfa: boolean;
  };
}
export interface IProcessBankResponse {
  success?: boolean;

  error?: string;
  type?: string;

  fields?: ISignupField[];
}

export interface IBankStrategyRequest {
  bankId: string;
  dataProviderId?: number;

  returnUrl?: string;
  disableNewTab:boolean;
}

export interface IOpenbankingStrategyRequest {
  bankId: string;
  returnUrl?: string;
  disableNewTab:boolean;
}

export interface ISignupState {
  firstname: string;
  lastname: string;
  email: string;
  telephone: string;
  employmentStatus: string;
  companyName: string;
  jobTitle: string;
  salary: string;
  payFrequency: string;

  dateOfBirth: string;
  postCode: string;
  addressLine1: string;
  addressLine2: string;
  postTown: string;

  bankId: string;
}

export interface IPagedRequest {
  page?: number;
  pageSize: number;
}

export interface IPagedResult<T> {
  items: T[];

  page: number;
  pageSize: number;
  pageCount: number;
  rowCount: number;
}

export interface ITokenParameters {
  completeUrl: string;
  cancelUrl: string;

  startBank: string;

  email: string;
  firstname: string;
  lastname: string;
  dateOfBirth: string;
  telephone: string;
  postCode: string;
  addressLine1: string;
  addressLine2: string;
  postTown: string;

  /* NEED A place in the UI */
  companyName: string;
  CompanyNumber: string;
  employmentStatus: string;
  /* /NEED A place in the UI */

  // only one
  externalRef: string;
  // /only one

  referrer: string[];

  // ??
  clientParametersKey: string;

  create: boolean;
}

export interface IAuthoriseResponse {
  newToken: string;
  bank: {
    search: string;
    item: IBankItem;
  };

  acceptedTerms: boolean;
  acceptedPrivacy: boolean;

  externalReference: string;

  allowSignup: boolean;
  expiredLink: boolean;
  client: string;

  sessionId: string;
  referenceGuid: string;
}

export interface IProgressResponse {
  code: OpenBankingProcessState;
  message?: string;
}

// export enum SignupPagesEnum {
//   Welcome = 1,
//   AboutYou,
//   AboutYouAddress,
//   AboutYouEmployment,

//   Connect = 50,
//   ConsentPage = 51,
//   Control = 52,
//   Consented = 53,

//   Success = 70,
//   Deny = 71,
//   Error = 72,
//   Declined = 73,

//   CompleteUrl = 200,
// }

export enum OpenBankingProcessState {
  Created = 0,
  Init = 1,

  Process = 2,
  Processed = 3,

  GettingTransactions = 10,
  TransactionFetched = 20,
  Categorise = 30,

  Success = 100,
  SuccessProcessing = 101,

  Error = 200,
  ErrorProcessing = 201,
  ErrorYodlee = 204,
  ErrorCancelled = 205,

  NotFound = 500,
  InvalidRequest = 501,
}

export interface IErrorRequest {
  href: string;
  source: string;
  lineno: string;
  colno: string;
  message: string;
  errorJson: string;
}

export interface IAuditRequest {
  action: string;
  info?: object;
}

export interface CompanySearchItem {
  description: string;
  companyNumber: string;
  companyStatus: string;

  address: string;
}

export interface ITextOverrides {
  welcome: Dictionary<string>;
  connect: Dictionary<string>;
  control: Dictionary<string>;
  consent: Dictionary<string>;
  error: Dictionary<string>;
  consented: Dictionary<string>;
  success: Dictionary<string>;
  faq: Dictionary<string>;
  declined: Dictionary<string>;
  deny: Dictionary<string>;
}

export interface IFileTransfer {
  content64: string;
  lastModifiedDate: Date;
  fileName: string;
}

export interface IPdfFileTransfer extends IFileTransfer {
  password: string;
}

//#region Pages

export interface ISignupAppConfig {
  app?: ISignupApp;

  provider: ISignupProvider;

  complete: ISignupComplete;

  footer?: ISignupFooter;

  pages: ISignupPage[];
}

export interface ISignupApp {
  defaultLocale?: string;
  termsConditions?: ISignupTermsAndCondition;
  noHeader?: boolean;
  noBurgerMenu?: boolean;
  noFooter?: boolean;
  showTips?: boolean;
}

export interface ISignupTermsAndCondition {
  location: string[];
  fields: ISignupPageField[];
}

export enum DataProvider {
  OpenBanking = 0,
  Yodlee = 1,
  YodleePdf = 2,
  // ReSharper disable once InconsistentNaming
  MX = 3,
  Enrich = 4,
  Starling = 5,
    TrueLayer = 6,
  MasterCard=7
}

export interface ISignupProvider {
  /**
   * If set to true the app will request data provider strategy when bank changes,
   * this allow the app to know before hand how to resolve open banking and yodlee strategy
   */
  resolveProvider: boolean;

  /**
   * Ordered list of supported DataProviders, this will allow to use as fallback in the future
   */
  allowedProviders: DataProvider[];

  /**
   * This will be used for yodlee in India where we allow to change providers
   */
  allowChangeProvider: boolean;

  /**
   * This will be used for open banking and opening a new tab for the bank, defaults to false. 
   */
  disableNewTab: boolean;
/**
   * This will be used to set timeout on reverselookup api call, defaults to 5. 
   */
  reverseLookUpRequestWaitTimeInSec: number;
   /**
   * This will be used to identify ApplyPlus Signup journey
   */
    applyPlusSignUp: number;
  /**
   * This will be Identify wether to auto redicet on error url or not
   */
  errorAutoRedirectEnabled: boolean;
  /**
  * This will be Identify wether to redicet error url configured or not
  */
  errorRedirectUrl: string;
  /**
  * This will be Identify wether to redicet to redirect.html or ThirdPartyThankyou.html and integrated specially for mobile app.
  */
  thirdPartyIntegrationApp: boolean;
  /**
  * This will be Identify wether to redicet to redirect.html or ThirdPartyThankyou.html and integrated specially for mobile app along with thirdPartyIntegrationApp.
  */
    earlyRedirectEnabled: boolean;
  /**
   * Label for the back button. Shows 'Back to creation' for creation clients, defaults to 'Back'.
   */
  backButton: string;
  /**
   * URL the back button redirects to.
   */
  backButtonUrl: string;
  /**
   * True when the current journey originated from the iframe (embed) entry point.
   * The iframe journey is driven solely by isBacktoClientEnabled and never falls back to DB back-button config.
   */
  isIframeJourney: boolean;
  /**
   * Iframe-supplied flag indicating the client wants a "back to client" button in the iframe journey.
   */
  isBacktoClientEnabled: boolean;
}

export interface ISignupComplete {
  /**
   * Auto redirect on success
   */
  autoRedirect: boolean;

  /**
   * Allow add multiple banks to the current signup
   */
  allowAddBank: boolean;

  /**
   * Allow the customer to close the tab
   */
  allowClose: boolean;

  /**
   * Allow the customer to download account pdf
   */
  allowDownloadPdf: boolean;

  /**
   * Show the green success tick icon on the success page (defaults to true)
   */
  showSuccessIcon?: boolean;

  /**
   * Show the 'What happens next?' subtitle on the success page (defaults to true)
   */
  showSuccessSubTitle?: boolean;
}

export interface ISignupFooter {
  /**
   * Replaces the footer logo
   */
  logo?: string;
  /**
   * Replaces the consents.online text
   */
  text?: string;
}

export interface ISignupPage {
  name: string;
  title: string;
  top: string;
  bottom: string;
  type: string;
  props?: object;
  fields?: ISignupPageField[];
}
export interface ISignupPageField {
  name: string;
  editor: string;
  placeholder: string;

  autocomplete?: string;

  dependentFields?: Dictionary<ISignupPageFieldValidation>;
  validations: Dictionary<ISignupPageFieldValidation>;
}

export interface ISignupPageFieldDependent {
  event: string;
}

export interface ISignupPageFieldValidation {
  type: string;

  value?: ISignupPageFieldValidationValue;
}

export interface ISignupPageFieldValidationValue {
  type: string;
  text: string;
}
//#endregion

export interface IAddressSearchRequest {
  postcode: string;
}

export interface IAddressSearchResponse {
  error: string;
  results: IAddress[];
}

export interface IAddress {
  country: string;
  county: string;
  number: string;
  postcode: string;
  postTown: string;
  street1: string;
  street2?: string;
  addressID: string;
  name?: string;
  district?: string;
  poBox?: string;
  subBuilding?: string;
}

export interface IConnectors {
  id: number;
  name: string;
  type: number;
  title: string;
}

export interface IValidisRequestWithExternalReference {
  externalReference?: string;
}

export interface IValidisUploadRequest extends IValidisRequestWithExternalReference {
  connectorName: string;
}

export interface IValidisUploadResponse {
  action: string;
  url: string;
}

export interface IValidisConfigDetailsResponse {
  engagementId?: number;
  hasValidisConfig: boolean;
  externalReference: string;
  userConsented: any;
  downloadLink: string;
  selectedAccountancyPackageObj: IConnectors;
}

export interface IScenarioMessageResponse {
    isCustomerHasScenarioMessage: boolean;
    customerScenarioMessageToDisplay: string;
    scenarioNumberOfTimeCounter: number;
}

export interface IUsernameCheckRequest {
  username: string;
}

export interface IClientConfigsSettings {
  configType: string;
  isEnabled: boolean;
}

export interface IReconsent {
  bankName: string;
  siteId: number;
} 

export interface IHouseholdComposition {
  householdType: string;
  zeroToOne: number;
  twoToFour: number;
  primary: number;
  secondary: number;
  adult: number;
  pensioner: number;
}

export interface IFinacialCircumstances {
  residentialStatus: string;
  employmentStatus: string;
}

export interface IIncome {
  declaredIncome: string;
  otherIncome: string;
  incomeType: string;
}

export interface IMonthlyExpenditure {
  loanRepayment: number;
  oustandingBalance: number;
  rentOrMortgage: number;
  utilities: number;
  councilTax: number;
  childcare: number;
  travel: number;
  housekeeping: number;
  other: number;
}
